import { render, staticRenderFns } from "./hidden-table.vue?vue&type=template&id=4a4ab2a7&scoped=true"
import script from "./hidden-table.vue?vue&type=script&lang=js"
export * from "./hidden-table.vue?vue&type=script&lang=js"
import style0 from "./hidden-table.vue?vue&type=style&index=0&id=4a4ab2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ab2a7",
  null
  
)

export default component.exports